import { unref as _unref, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "social-media-popup" }
const _hoisted_2 = { class: "popup-main" }
const _hoisted_3 = { class: "popup-content" }
const _hoisted_4 = { class: "social-media-list flex justify-center" }
const _hoisted_5 = { class: "social-media-item" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "social-media-name" }, "Facebook", -1)
const _hoisted_7 = { class: "social-media-item" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "social-media-name" }, "Telegram", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "follow-text" }, "Follow and like us on Official Facebook and Telegram pages and get updates for our latest activities and bonuses!", -1)

import { ref } from 'vue';
import { useHelpTool } from '@/hooks';


export default {
  __name: 'Follow',
  emits: ['onClose'],
  setup(__props, { emit: __emit }) {

const emit = __emit

const { doFollow, backgroundByTheme, imageByTheme } = useHelpTool()

return (_ctx, _cache) => {
  const _component_van_image = _resolveComponent("van-image")
  const _component_van_popup = _resolveComponent("van-popup")
  const _directive_audio = _resolveDirective("audio")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_popup, {
      class: "full-page",
      show: true,
      "close-on-click-overlay": false
    }, {
      default: _withCtx(() => [
        _withDirectives(_createVNode(_component_van_image, {
          class: "close-icon",
          src: _unref(imageByTheme)('close.png'),
          onClick: _cache[0] || (_cache[0] = $event => (emit('onClose')))
        }, null, 8, ["src"]), [
          [_directive_audio, void 0, "close"]
        ]),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", {
            class: "popup-header",
            style: _normalizeStyle(_unref(backgroundByTheme)('follow-bg.png'))
          }, [
            _createElementVNode("div", {
              class: "popup-title",
              style: _normalizeStyle(_unref(backgroundByTheme)('redeem-input.png'))
            }, _toDisplayString(_ctx.$t('socialMedia.followRewards').toUpperCase()), 5)
          ], 4),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _hoisted_6,
                _createVNode(_component_van_image, {
                  class: "social-media-img",
                  src: require('@/assets/img/follow/facebook.png')
                }, null, 8, ["src"]),
                _withDirectives((_openBlock(), _createElementBlock("div", {
                  class: "follow-btn",
                  onClick: _cache[1] || (_cache[1] = $event => (_unref(doFollow)({ type: 'facebook' })))
                }, [
                  _createTextVNode("+" + _toDisplayString(_ctx.$t('common.follow')), 1)
                ])), [
                  [_directive_audio]
                ])
              ]),
              _createElementVNode("div", _hoisted_7, [
                _hoisted_8,
                _createVNode(_component_van_image, {
                  class: "social-media-img",
                  src: require('@/assets/img/follow/telegram.png')
                }, null, 8, ["src"]),
                _withDirectives((_openBlock(), _createElementBlock("div", {
                  class: "follow-btn",
                  onClick: _cache[2] || (_cache[2] = $event => (_unref(doFollow)({ type: 'telegram' })))
                }, [
                  _createTextVNode("+" + _toDisplayString(_ctx.$t('common.follow')), 1)
                ])), [
                  [_directive_audio]
                ])
              ])
            ]),
            _hoisted_9
          ])
        ])
      ]),
      _: 1
    })
  ]))
}
}

}